import React, { memo } from 'react';
import { Box } from '@mui/material';

interface ImageItemProps {
  image: string;
  alt: string;
}

const ImageItem: React.FC<ImageItemProps> = memo(({ image, alt }) => {
  if (!image) {
    return <></>;
  }

  return (
    <Box
      sx={{
        position: 'relative',
        width: 'auto',
        height: '100%',
        aspectRatio: '16/9',
        overflow: 'hidden',
        borderRadius: (theme) => theme.shape.borderRadiusLg,
      }}
    >
      <Box
        component='img'
        src={image}
        alt={`${alt}-background`}
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          filter: 'blur(10px)',
          transform: 'scale(1.1)',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1,
        }}
      />
      <Box
        component='img'
        src={image}
        alt={alt}
        sx={{
          position: 'relative',
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          zIndex: 2,
        }}
      />
    </Box>
  );
});

export default ImageItem;

// better approach
// import React, { memo, useState } from 'react';
// import { Box } from '@mui/material';

// interface ImageItemProps {
//   image: string;
//   alt: string;
// }

// const ImageItem: React.FC<ImageItemProps> = memo(({ image, alt }) => {
//   const [imageLoaded, setImageLoaded] = useState(false);

//   if (!image) {
//     return <></>;
//   }

//   return (
//     <Box
//       sx={{
//         position: 'relative',
//         width: 'auto',
//         height: '100%',
//         aspectRatio: '16/9',
//         overflow: 'hidden',
//         borderRadius: (theme) => theme.shape.borderRadiusLg,
//         backgroundImage: `url(${image})`,
//         backgroundSize: 'cover',
//         backgroundPosition: 'center',
//         '&::before': {
//           content: '""',
//           position: 'absolute',
//           top: 0,
//           left: 0,
//           width: '100%',
//           height: '100%',
//           backdropFilter: 'blur(10px)',
//           backgroundColor: 'rgba(0, 0, 0, 0.5)',
//           zIndex: 1,
//         }
//       }}
//     >
//       <Box
//         component='img'
//         src={image}
//         alt={alt}
//         onLoad={() => setImageLoaded(true)}
//         sx={{
//           position: 'relative',
//           width: '100%',
//           height: '100%',
//           objectFit: 'contain',
//           zIndex: 2,
//           opacity: imageLoaded ? 1 : 0,
//           transition: 'opacity 0.3s ease-in-out',
//         }}
//       />
//     </Box>
//   );
// });

// export default ImageItem;